import { useEffect, useState } from 'react';

export const AUTH_SESSION_CHANGED = 'avwf:auth-session-changed';
let revision = 0;
export const notifyAuthSessionChanged = () => {
  revision += 1;
  window.dispatchEvent(new Event(AUTH_SESSION_CHANGED));
};
if (typeof window !== 'undefined') {
  window.addEventListener('storage', event => {
    if (event.key === 'PLS' || event.key === null) notifyAuthSessionChanged();
  });
}

export function readChatSessionIdentity(includeRevision = true): string {
  const suffix = includeRevision ? `:${revision}` : '';
  try {
    const session = JSON.parse(localStorage.getItem('PLS') || 'null');
    const principal = session?.principal ?? session?.user ?? session;
    const id = Number(principal?.id);
    if (!Number.isSafeInteger(id) || id <= 0) return `anonymous${suffix}`;
    const company = window.location.pathname.match(/^\/companies\/(\d+)(?:\/|$)/)?.[1] ?? 'active-grant';
    return `${session?.authMode ?? 'legacy'}:${principal.realm ?? 'legacy'}:${id}:${principal.role ?? principal.Role?.name ?? ''}:${company}${suffix}`;
  } catch {
    return `invalid${suffix}`;
  }
}

/** React17-compatible subscription; no token is placed in query keys or DOM keys. */
export function useAuthSessionRevision() {
  const [value, setValue] = useState(revision);
  useEffect(() => {
    const update = () => setValue(revision);
    window.addEventListener(AUTH_SESSION_CHANGED, update);
    return () => window.removeEventListener(AUTH_SESSION_CHANGED, update);
  }, []);
  return value;
}

export function readChatActorId(): number | undefined {
  try {
    const session = JSON.parse(localStorage.getItem('PLS') || 'null');
    const id = Number((session?.principal ?? session?.user ?? session)?.id);
    return Number.isSafeInteger(id) && id > 0 ? id : undefined;
  } catch { return undefined; }
}
